import { FiUser } from "react-icons/fi";
import Buttons from "../../../components/button";
import { HStack } from "../../../components/composition/stack.layout";
import useRouterVariable from "../../../components/utils/useRouterVariable";
import {
  logoutAgencyContact,
  logoutApplicant,
  useFetchOrgColor,
} from "../../api-docs";
import Menu from "../../../components/menu";
import { useState } from "react";
import { useRouter } from "next/router";
import { URLS } from "../../../utils/urls";

export function EmailSignInButton(props: {
  isAgencyContact?: boolean;
  onClick: () => void;
  isLoggedIn?: {
    email: string;
  };
}) {
  const [menuOpen, setMenuOpen] = useState(false);
  const orgFriendlyName = useRouterVariable("org", (o) => o as string);
  const orgColor = useFetchOrgColor(
    {
      orgFriendlyName,
    },
    {
      query: {
        enabled: orgFriendlyName != null,
      },
    },
  );

  const router = useRouter();

  if (props.isLoggedIn) {
    return (
      <Menu
        align="end"
        onRequestClose={setMenuOpen}
        isOpen={menuOpen}
        items={[
          {
            label: () => {
              return <span>Sign out</span>;
            },
            action: () => {
              if (props.isAgencyContact) {
                logoutAgencyContact().then(async () => {
                  await router.push(
                    URLS.agencySelfApplyJobsList(
                      orgFriendlyName as string,
                      null,
                    ),
                  );
                  window.location.reload();
                });
              } else {
                logoutApplicant().then(async () => {
                  window.location.reload();
                });
              }
            },
          },
        ]}
        trigger={() => {
          return (
            <HStack className="items-center space-x-2 truncate p-2">
              <span>
                <FiUser
                  fill={orgColor.data ?? "#444"}
                  stroke={orgColor.data ?? "#444"}
                />
              </span>

              <p className="truncate text-base font-semibold">
                {props.isLoggedIn?.email ?? ""}
              </p>
            </HStack>
          );
        }}
      ></Menu>
    );
  }

  return (
    <Buttons.Base variant="ghost" className="p-2" onClick={props.onClick}>
      <HStack className="items-center space-x-2 p-2">
        <FiUser fill={orgColor.data} stroke={orgColor.data} />
        <div className="text-base font-semibold">Email Sign In</div>
      </HStack>
    </Buttons.Base>
  );
}
